import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { getConsent, initConsent, setConsent } from '../utils/consent';

/**
 * Cookie / tracking consent banner. Advertising and analytics placeholders stay
 * dormant until the visitor grants consent.
 */
export function CookieConsent() {
  const {
    t
  } = useLanguage();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    initConsent();
    setVisible(getConsent() === 'unset');
  }, []);
  if (!visible) return null;
  const decide = (choice: 'granted' | 'denied') => {
    setConsent(choice);
    setVisible(false);
  };
  return <div role="dialog" aria-label={t('Cookie preferences', 'Preferencias de cookies')} className="fixed inset-x-0 bottom-[76px] z-[60] mx-auto max-w-editorial px-4 md:bottom-4" data-id="element-163" data-mp="knzeejxdts80">
      <div className="flex flex-col gap-4 border border-white/15 bg-midnight p-5 lg:flex-row lg:items-center lg:justify-between lg:p-6" data-id="element-164" data-mp="1dcn7v2sabnwn">
        <p className="max-w-2xl text-[13px] leading-relaxed text-white/80" data-id="element-165" data-mp="2g6nd0curskm4">
          {t('We use limited analytics and advertising cookies to measure how this property page performs. You can decline without affecting your ability to contact Veronica.', 'Usamos cookies limitadas de análisis y publicidad para medir el rendimiento de esta página. Puedes rechazarlas sin afectar tu posibilidad de contactar a Veronica.')}{' '}
          <Link to="/privacy-policy" className="underline decoration-gold/60 underline-offset-2 hover:text-gold" data-id="element-166" data-mp="21gg3immqqbxk">
            {t('Privacy Policy', 'Política de Privacidad')}
          </Link>
        </p>
        <div className="flex shrink-0 gap-3" data-id="element-167" data-mp="1sh1hbzdlwniv">
          <button type="button" onClick={() => decide('denied')} className="border border-white/30 px-5 py-3 font-display text-[11px] font-medium uppercase tracking-[0.16em] text-white transition-colors duration-150 ease-out hover:border-gold hover:text-gold" data-id="element-168" data-mp="1shumivwx34yw">
            {t('Decline', 'Rechazar')}
          </button>
          <button type="button" onClick={() => decide('granted')} className="bg-gold px-5 py-3 font-display text-[11px] font-medium uppercase tracking-[0.16em] text-midnight transition-colors duration-150 ease-out hover:bg-gold-soft" data-id="element-169" data-mp="3gc7m7ej26g6x">
            {t('Accept', 'Aceptar')}
          </button>
        </div>
      </div>
    </div>;
}